const baseURL = 'https://tiendayki.com/';

export default baseURL;
